import { isTruthy } from './isTruthy';
import { OptInEnum } from './types/enums';
import { mapAdobe } from './mapAdobe';
export var mapContext = function (initParams, win, eventOptions) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        adobe: mapAdobe(initParams),
        app: initParams.application,
        browser: {
            viewportWidth: win.innerWidth,
            viewportHeight: win.innerHeight,
        },
        library: {
            name: '@sb1/web-behavior-tracker',
            version: '13.6.3',
        },
        optIn: [
            initParams.user.optins.functional && OptInEnum.Functional,
            initParams.user.optins.marketing && OptInEnum.Marketing,
            initParams.user.optins.statistics && OptInEnum.Statistics,
        ].filter(isTruthy),
        page: {
            referrer: (_a = eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.referrer) !== null && _a !== void 0 ? _a : win.document.referrer,
            title: (_b = eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.title) !== null && _b !== void 0 ? _b : win.document.title,
            url: (_c = eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.url) !== null && _c !== void 0 ? _c : win.location.href,
            language: initParams.user.language,
            type: eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.type,
        },
        screen: {
            width: win.screen.width,
            height: win.screen.height,
            density: Math.floor(win.devicePixelRatio * 1000) / 1000,
            orientation: mapOrientation((_e = (_d = win.screen) === null || _d === void 0 ? void 0 : _d.orientation) === null || _e === void 0 ? void 0 : _e.type),
        },
        sessionId: (_f = initParams.user.sessionId) !== null && _f !== void 0 ? _f : undefined,
        userAgent: win.navigator.userAgent,
        product: mapProduct(eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.product, initParams.product),
    });
};
var mapOrientation = function (winOrientation) {
    if (winOrientation === 'portrait') {
        return 'portrait';
    }
    else if (winOrientation === 'portrait-primary') {
        return 'portrait';
    }
    else if (winOrientation === 'portrait-secondary') {
        return 'portrait';
    }
    else if (winOrientation === 'landscape') {
        return 'landscape';
    }
    else if (winOrientation === 'landscape-primary') {
        return 'landscape';
    }
    else if (winOrientation === 'landscape-secondary') {
        return 'landscape';
    }
    else {
        return undefined;
    }
};
var mapProduct = function (eventProduct, paramsProduct) {
    if (eventProduct)
        return eventProduct;
    return paramsProduct ? paramsProduct : undefined;
};
//# sourceMappingURL=mapContext.js.map